import { Injectable } from '@angular/core';

import { QRCodeToDataURLOptions, toDataURL } from 'qrcode';

import { QrCodeType } from './qrcode.constants';
import { CheckinReasonQrData, FlexTimeActivityQrData, IdQrData, QrData, WebisteUrlQrData } from './qrcode.types';

@Injectable({ providedIn: 'root' })
export default class QrCodeService {
  /** Service Constructor */
  constructor() {}

  public async createCheckinReasonQrCode(reasonId: number) {
    if (!reasonId) return;
    const qrData: QrData<CheckinReasonQrData> = {
      type: QrCodeType.CHECKIN_REASON,
      data: {
        reasonId,
      },
    };
    const asString = JSON.stringify(qrData);
    const uriData = await this._generateQrCodeAsUrl(asString);
    return uriData;
  }

  public readCheckinReasonQrCode(dataString: string): CheckinReasonQrData {
    const parsedData = JSON.parse(dataString) as QrData<CheckinReasonQrData>;
    if (!parsedData.type) throw new Error('Failed to read QR string');
    return parsedData.data;
  }

  private async _generateQrCodeAsUrl(text: string, options?: QRCodeToDataURLOptions): Promise<string> {
    try {
      const result = await toDataURL(text, options);
      return result;
    } catch (err) {
      console.error(err);
    }
  }

  public async createIdQrCode(id: string) {
    if (!id) return;
    const qrData: QrData<IdQrData> = {
      type: QrCodeType.ID,
      data: {
        id,
      },
    };
    const asString = JSON.stringify(qrData);
    const uriData = await this._generateQrCodeAsUrl(asString);
    return uriData;
  }

  public readIdQrCode(dataString: string): IdQrData {
    const parsedData = JSON.parse(dataString) as QrData<IdQrData>;
    if (!parsedData.type) throw new Error('Failed to read QR string');
    return parsedData.data;
  }

  public async createFlexTimeActivityQrCode(id: string) {
    if (!id) return;
    const qrData: QrData<FlexTimeActivityQrData> = {
      type: QrCodeType.FLEX_TIME_ACTIVITY,
      data: {
        id,
      },
    };
    const asString = JSON.stringify(qrData);
    const uriData = await this._generateQrCodeAsUrl(asString);
    return uriData;
  }

  public readFlexTimeActivityQrCode(dataString: string): FlexTimeActivityQrData {
    const parsedData = JSON.parse(dataString) as QrData<FlexTimeActivityQrData>;
    if (!parsedData.type) throw new Error('Failed to read QR string');
    if (parsedData.type !== QrCodeType.FLEX_TIME_ACTIVITY) {
      throw new Error('QR code is not a Flex Time Activity QR code');
    }
    return parsedData.data;
  }

  public async createWebsiteUrlQrCode(url: string) {
    if (!url) return;
    const qrData: QrData<WebisteUrlQrData> = {
      type: QrCodeType.WEBSITE_URL,
      data: {
        url,
      },
    };
    const asString = JSON.stringify(qrData);
    const uriData = await this._generateQrCodeAsUrl(asString);
    return uriData;
  }
}
